/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WrenchIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABGklEQVR4nN3UQUoDQRAF0EbdiUKuIF5Bt7MKBMaq+hHGKqNHUQYhqOAFxJV4ANEr6FIRXQheI5ClEukgojhj97SzkHyoVVfV64ZhnJvZMPMSQS8JelfXQ9B73+N7Gy3v9XaWGfrEsImv2kt8nLPYYyOEYRefw4gApoieRy0Htte/DSISgE02+ltrQYBEz1IBgp6GAdhLOmDPQYCh41SAoeMYYFTxdMnzQedrMVu/AhiFAf/J/Ri0qCLoQ8QL7CQVYNhxECAqVkn0rfHtxV7zzcFKEJgiYsME4MDFJsuyBYJeRwNiV0VRzLsmKctyjsSOwsv10Pe61JDo/i/Anvtrut3dxTrAn7k2wjVAK8tnBBC9rfhz3rQG/Ou8AyEieKzlhUKMAAAAAElFTkSuQmCC)
 */
export const WrenchIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.8 15.77c.7.43 1.2 1.14 1.2 1.96V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.27c0-.82.5-1.53 1.2-1.96a8.06 8.06 0 0 0 .12-13.63c-.6-.39-1.32.09-1.32.8v5.98a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V2.94c0-.71-.72-1.19-1.32-.8a8.06 8.06 0 0 0 .12 13.63Z"
        className={colorClass}
      />
    </svg>
  );
};
